import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { sendMobileErrorNotification, sendMobileLoadedNotification } from '@ecs-uk/web-common-mobile-view-helpers';
import CancelSubscriptionPage from '../../cancel-subscription';

const MobileCancelSubscriptionPage = ({ isBlockedByKillSwitch = false }) => {
  useEffect(() => {
    if (isBlockedByKillSwitch) {
      sendMobileErrorNotification();
    } else {
      sendMobileLoadedNotification();
    }
  }, [isBlockedByKillSwitch]);

  if (isBlockedByKillSwitch) {
    return null;
  }

  return <CancelSubscriptionPage isWebview />;
};

MobileCancelSubscriptionPage.propTypes = {
  isBlockedByKillSwitch: PropTypes.bool,
};

export default MobileCancelSubscriptionPage;
